import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=10b35604&scoped=true&"
import script from "./LoadingScreen.vue?vue&type=script&lang=js&"
export * from "./LoadingScreen.vue?vue&type=script&lang=js&"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&id=10b35604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b35604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b35604')) {
      api.createRecord('10b35604', component.options)
    } else {
      api.reload('10b35604', component.options)
    }
    module.hot.accept("./LoadingScreen.vue?vue&type=template&id=10b35604&scoped=true&", function () {
      api.rerender('10b35604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoadingScreen.vue"
export default component.exports